// Las cuentas del dueño quedan fuera del listado y sus contadores.
export const prepararUsuariosMaster = (loadedUsers, authUsers) => {
  const clasificaciones = new Map(loadedUsers.filter(user => user.soloClasificacion).map(user => [user.id, user]));
  loadedUsers = loadedUsers.filter(user => !user.soloClasificacion);
  const authByUid = new Map(authUsers.map((user) => [user.uid, user]));
  const authByEmail = new Map(
    authUsers
      .filter((user) => user.email)
      .map((user) => [user.email.trim().toLowerCase(), user])
  );
  const firestoreUids = new Set(loadedUsers.map((user) => user.id));

  const usersWithAccessStatus = loadedUsers.filter((user) => user.isSuperAdmin !== true).map((user) => {
    const normalizedEmail = String(user.email || '').trim().toLowerCase();
    const authUserByUid = authByUid.get(user.id);
    const authUserByEmail = authByEmail.get(normalizedEmail);
    const authUser = authUserByUid || authUserByEmail;

    return {
      ...user,
      authAccessStatus: authUserByUid
        ? 'complete'
        : authUserByEmail
          ? 'uid-mismatch'
          : 'missing-auth',
      authDisabled: authUser?.disabled === true,
    };
  });

  authUsers.forEach((authUser) => {
    if (authUser.isSuperAdmin === true) return;
    if (firestoreUids.has(authUser.uid)) return;

    const normalizedEmail = String(authUser.email || '').trim().toLowerCase();
    const isLinkedByEmail = loadedUsers.some(
      (user) => String(user.email || '').trim().toLowerCase() === normalizedEmail
    );
    if (isLinkedByEmail) return;

    usersWithAccessStatus.push({
      id: authUser.uid,
      uid: authUser.uid,
      email: authUser.email,
      displayName: authUser.displayName || authUser.email || 'Usuario sin perfil',
      estatus: authUser.disabled ? 'Inactivo' : 'Activo',
      teacher: false,
      isMaster: false,
      authAccessStatus: 'missing-profile',
      authDisabled: authUser.disabled === true,
      ...(clasificaciones.has(authUser.uid) ? {
        ocultoEnListados: clasificaciones.get(authUser.uid).ocultoEnListados,
        usuarioPrueba: clasificaciones.get(authUser.uid).usuarioPrueba,
      } : {}),
    });
  });

  return usersWithAccessStatus;
};
